import { BreadcrumbsSection } from './BreadcrumbsSection'

export default BreadcrumbsSection
